export default [
  {
    path: '/activity/freeexperience',
    component: resolve =>
      require(['@/pages/activity/freechannel/order.vue'], resolve)
  },
  {
    path: '/activity/freesuccess',
    component: resolve =>
      require(['@/pages/activity/freechannel/success.vue'], resolve)
  },
  {
    path: '/activity/yzsuccess',
    component: resolve =>
      require(['@/pages/activity/freechannel/successyz.vue'], resolve)
  },

  {
    path: '/activity/brc',
    component: resolve => require(['@/pages/activity/brc.vue'], resolve)
  },
  {
    path: '/activity/yz/mobile',
    component: resolve => require(['@/pages/activity/yz/mobile.vue'], resolve)
  },
  {
    path: '/activity/yz/switchmobile',
    component: resolve => require(['@/pages/activity/yz/mobile.vue'], resolve)
  },
  {
    path: '/activity/yz/mobileconfirm',
    component: resolve =>
      require(['@/pages/activity/yz/mobileconfirm.vue'], resolve)
  },
  // 课程签到相关页面
  {
    path: '/activity/signuplogin',
    component: resolve =>
      require(['@/pages/activity/signup/mobile.vue'], resolve)
  },
  {
    path: '/activity/signup',
    component: resolve =>
      require(['@/pages/activity/signup/index.vue'], resolve)
  },
  // 优惠券领取页面相关页面
  {
    path: '/coupon/index',
    component: resolve =>
      require(['@/pages/activity/coupon/index.vue'], resolve)
  },
  {
    path: '/coupon/productlist',
    component: resolve =>
      require(['@/pages/activity/coupon/productlist.vue'], resolve)
  },
  {
    path: '/coupon/order',
    component: resolve =>
      require(['@/pages/activity/coupon/order.vue'], resolve)
  }
]
